window.onscroll = function() {
    const timer = document.querySelector('#shopify-section-announcement-bar');
    const headerfixed = document.querySelector('.section-header');

    if (timer) {
        if (window.scrollY > 1) {
            timer.classList.add('top-fixed');
        } else {
            timer.classList.remove('top-fixed');
        }
    }

    if (headerfixed) {
        if (window.scrollY > 1) {
            headerfixed.classList.add('header-fixed');
        } else {
            headerfixed.classList.remove('header-fixed');
        }
    }
};
